import * as React from "react"
import { makeSlot, SLOT_KEY } from "@workspace/ui/lib/makeSlot"

type TopbarVariant = "solid" | "elevated" | "transparent"
type TopbarSize = "sm" | "md" | "lg"
type TopbarColor = "primary" | "secondary" | "transparent"

type TopbarProps = {
    variant?: TopbarVariant
    size?: TopbarSize
    color?: TopbarColor
    sticky?: boolean
    className?: string
}

const VARIANT = {
    solid: "",
    elevated: "shadow-sm",
    transparent: "",
}

const SIZE = {
    sm: "h-12 px-3",
    md: "h-14 px-4",
    lg: "h-16 px-6",
}

const COLOR = {
    primary: "bg-primary text-primary-foreground",
    secondary: "bg-secondary text-secondary-foreground",
    transparent: "bg-transparent",
}

export const Topbar: React.FC<TopbarProps> & {
    Left: any
    Center: any
    Right: any
} = ({
    variant = "elevated",
    size = "md",
    color = "primary",
    sticky = false,
    className,
    children,
}) => {
        const slots: Record<string, React.ReactNode> = {}

        React.Children.forEach(children, (child) => {
            if (!React.isValidElement(child)) return
            const key = (child.type as any)[SLOT_KEY]
            if (!key) return
            slots[key] = child.props.children
        })

        return (
            <div
                className={[
                    "flex items-center shrink-0",
                    VARIANT[variant],
                    SIZE[size],
                    COLOR[color],
                    sticky ? "sticky top-0 z-50" : "",
                    "w-[calc(100%+var(--removed-body-scroll-bar-size,0px))]",
                    "mr-[calc(-1*var(--removed-body-scroll-bar-size,0px))]",
                    className ?? "",
                ].join(" ")}
            >
                <div className="flex items-center gap-2 w-1/3">
                    {slots["topbar-left"]}
                </div>

                <div className="hidden md:flex justify-center w-1/3">
                    {slots["topbar-center"]}
                </div>

                <div className="hidden sm:flex justify-end items-center gap-3 w-1/3">
                    {slots["topbar-right"]}
                </div>
            </div>
        )
    }

Topbar.Left = makeSlot("topbar-left")
Topbar.Center = makeSlot("topbar-center")
Topbar.Right = makeSlot("topbar-right")
